import { Component, Input, TemplateRef, OnInit } from '@angular/core';

@Component({
  selector: 'ls-info-setting-tooltip',
  styleUrls: ['./info-setting-tooltip.component.scss'],
  template: `
    <div class="o-tooltip o-tooltip__form">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      <div class="o-tooltip__popup">
        <ng-container
          *ngIf="!tooltipString; else string"
          [ngTemplateOutlet]="tooltip"
        ></ng-container>
        <ng-template #string>{{ tooltip | lsTranslate }}</ng-template>
      </div>
    </div>
  `
})
export class InfoSettingTooltipComponent implements OnInit {
  @Input()
  public tooltip: string | TemplateRef<any>;
  public tooltipString = true;

  public ngOnInit() {
    this.tooltipString = typeof this.tooltip === 'string';
  }
}
